import { api } from "@/lib/api";

export async function fetchBillingPlans() {
  const { data } = await api.get("/billing/plans");
  return data;
}

export async function fetchSubscriptionStatus() {
  const { data } = await api.get("/billing/subscription");
  return data;
}

export async function createCheckoutSession(planCode) {
  const { data } = await api.post("/billing/checkout-session", { plan_code: planCode });
  return data;
}

export async function createPortalSession() {
  const { data } = await api.post("/billing/portal-session");
  return data;
}
